import { useState, useCallback } from 'react';
import { API_URL, apiClient } from '../config/api';

export const useSubscription = (token, showMessage) => {
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);

  // Fetch real subscription quotas, limits, active counts, and invoice history
  const fetchSubscriptionData = useCallback(async () => {
    if (!token) return;
    setIsLoadingSubscription(true);
    try {
      const response = await apiClient('/api/subscription/current');
      if (response.ok) {
        const data = await response.json();
        setSubscriptionData(data);
      }
    } catch (error) {
      console.error('Fetch subscription data error:', error);
    } finally {
      setIsLoadingSubscription(false);
    }
  }, [token]);

  // Open / download printable official invoice receipt
  const handleDownloadInvoice = async (invoiceId) => {
    if (!token || !invoiceId) return;
    try {
      const receiptWindow = window.open('', '_blank');
      if (receiptWindow) {
        receiptWindow.document.write('<div style="font-family:sans-serif;padding:24px;text-align:center;">Generating official tax invoice...</div>');
      }

      const response = await apiClient(`/api/subscription/invoices/${invoiceId}/download`);
      if (response.ok) {
        const html = await response.text();
        if (receiptWindow) {
          receiptWindow.document.open();
          receiptWindow.document.write(html);
          receiptWindow.document.close();
        } else {
          const blob = new Blob([html], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        }
      } else {
        if (receiptWindow) receiptWindow.close();
        if (showMessage) showMessage('Failed to download invoice receipt.', 'error');
      }
    } catch (error) {
      if (showMessage) showMessage('Network error downloading invoice receipt.', 'error');
    }
  };

  return {
    subscriptionData,
    isLoadingSubscription,
    fetchSubscriptionData,
    handleDownloadInvoice,
  };
};
